import { useLanguageContext } from "../../../../../context/LanguageContext";
import FileHelper from "../../../../../helpers/FileHelper";

export default function ImageLabelItem({ item, images }) {
  const { translateEntity } = useLanguageContext();
  const image = item.image ?? images?.find((img) => img.id === item.image_id);

  return (
    image && (
      <img
        src={FileHelper.apiPath(translateEntity(image, "path"))}
        alt={"label item"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    )
  );
}
